import { useEffect, useState } from 'react';

import Icon from '../../components/stateless/Icon';
import Heading from '../../components/stateless/Heading';
import Description from '../../components/stateless/Description';
import Button from '../../components/statefull/Button';

import './index.scss';

function NotFound() {
  return (
    <div className="not-found-page">
      <Icon icon="not-found-icon" />
      <Heading content="Page Not Found" size="extra" />
      <Description content="Something went wrong, there is no Spring in here." size="extra" />
      <Button link="/home" content="Back to Home" filled={true} />
    </div>
  )
};

export default NotFound;
